import React from 'react';

const TodoItem = (props) => {
  return(
    <div className="todoItem">
      <span>{props.value}</span>
      <button className="doneBtn" onClick={props.handleDeleteTodo}>&#8730;</button>
    </div>
  );
}

export default TodoItem;


// WEBPACK FOOTER //
// ./src/components/TodoItem.js